import { Button } from "@mui/material";
import { useCallback, useState } from "react";
import { CandidateDetails } from "../../../redux/Hire/jobRequestApi";
import RestoreCandidateModal from "../../HireV3/RestoreCandidateModal";

type Props = {
  candidate?: CandidateDetails;
};

const RestoreCandidate = ({ candidate }: Props) => {
  const [showModal, setShowModal] = useState(false);

  const handleOpen = useCallback(() => setShowModal(true), []);
  const handleClose = useCallback(() => setShowModal(false), []);
  if (!candidate) return null;
  return (
    <>
      <RestoreCandidateModal
        showModal={showModal}
        onClose={handleClose}
        candidateId={candidate?.id}
        candidateName={candidate?.name}
        jobId={Number(candidate?.jobId) || 0}
        stage={candidate?.stage || ""}
        positiveResponse={handleClose}
      />
      <Button variant="outlined" onClick={handleOpen}>
        Restore Candidate
      </Button>
    </>
  );
};

export default RestoreCandidate;
